import React, { Component } from 'react';
import './App.css';
import SurveyList from './components/SurveyList';
import Results from './components/Results';

class App extends Component {
  render() {
    return (
      <div id='head'>
        <div className='container'>
          <div className='header'>
            <h1>
              <strong>
                COVID-19 FOR <span className='highlight'>21</span>
              </strong>
            </h1>
            <h5>
              Number of days in the LOCKDOWN time period | GST Code for Odisha |
              Target year to build more resilient Odisha
            </h5>
          </div>
          <div className='row text-center box-border'>
            <SurveyList />
          </div>
          <div className='row text-center box-border' id='surveyStart'>
            <Results />
          </div>
        </div>
        <footer>
          <div className='text-center py-3'>
            © 2020 Copyright:
            <a href='https://jontycool.github.io/'> Tathagat Mohanty</a>
          </div>
        </footer>
      </div>
    );
  }
}

export default App;
